import type { ReactNode } from "react";
import Link from "next/link";

type AuthPageHeaderProps = {
  title: string;
  // 文字列のほか、リンクを含む要素も渡せる（企業ログインの「通常ログインページは こちら」）。
  subtitle: ReactNode;
};

export default function AuthPageHeader({ title, subtitle }: AuthPageHeaderProps) {
  return (
    <div className="text-center mb-8">
      <Link href="/" className="inline-flex items-center gap-2 mb-6">
        <img src="/logo_menren.svg" alt="MENREN" className="h-10" />
      </Link>
      <h1 className="text-2xl font-bold text-text">{title}</h1>
      <p className="text-gray-500 mt-2 text-sm">{subtitle}</p>
    </div>
  );
}
